<bzg-modal-header>
  <div class="bmc-deployment-decrypt__header">
      <span>{{'DEPLOYMENT.DECRYPT_TITLE' | translate}}</span>
      <bzg-button-icon icon="icon-close" (click)="close()"></bzg-button-icon>
  </div>
</bzg-modal-header>
<bzg-modal-content>
  <div>
      <span class="bmc-deployment-decrypt__text bz-space--stack-m">{{'DEPLOYMENT.DECRYPT_INFO' | translate}}</span>
      <div class="bmc-deployment-decrypt__file bz-space--stack-m">
        <strong class="bmc-deployment-decrypt__file__label bz-space--stack-xs">{{'DEPLOYMENT.DECRYPT_LABEL_FILE_NAME' | translate}}</strong>
        <span class="bmc-deployment-decrypt__file__text">{{data.fileName}}</span>
      </div>
      <bzg-password class="bmc-deployment-decrypt__password-input" [(ngModel)]='password' [required]="true" >
        {{'GLOBAL.PASSWORD' | translate}}
        <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
      </bzg-password>
  </div>
</bzg-modal-content>
<bzg-modal-footer class="bmc-delete-alert__footer">
  <bzg-button-secondary (click)="close()" class="bz-space--inline-m">{{ 'GLOBAL.CANCEL' | translate }}
  </bzg-button-secondary>
  <bzg-button-primary (click)="confirm()">{{'DEPLOYMENT.DECRYPT_UPLOAD_BUTTON' | translate}}</bzg-button-primary>
</bzg-modal-footer>
